import { render, staticRenderFns } from "./mo-textarea.html?vue&type=template&id=2cf058d2&external"
import script from "./mo-textarea.ts?vue&type=script&lang=ts&external"
export * from "./mo-textarea.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports